import { ToastUtilities } from "@src/libs/react-toastify/ToastUtilities";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { useQuery } from "react-query";

export const useLoadedFileURLKey = (storagePath: string | undefined | null, externalFileInformation?: { propertyID: string; fileID: string }) => {
  return ["file", storagePath, externalFileInformation];
};

export const useLoadedFileURL = (storagePath: string | undefined | null, externalFileInformation?: { propertyID: string; fileID: string }) => {
  const storage = getStorage();

  const $file = useQuery(
    useLoadedFileURLKey(storagePath, externalFileInformation),
    async (): Promise<string | undefined> => {
      if (storagePath) {
        const reference = ref(storage, storagePath);
        return getDownloadURL(reference);
      } else if (externalFileInformation) {
        const functions = getFunctions(undefined, "europe-west1");
        const getExternalFileURL = httpsCallable(functions, "getExternalFileURL");
        return getExternalFileURL({
          propertyID: externalFileInformation.propertyID,
          fileID: externalFileInformation.fileID,
        })
          .then((response) => {
            if (typeof response.data === "string") {
              return response.data;
            }
            return undefined;
          })
          .catch((error) => {
            ToastUtilities.presentServerError(error);
            return undefined;
          });
      }
      return undefined;
    },
    {
      enabled: !!storagePath || !!externalFileInformation,
    }
  );

  return { $file, fileURL: $file.data };
};
